import Vue from 'vue';
import Help from '~/pages/help.vue';
import RasylvaApi from '~/plugins/rasylva-api';

Vue.use(RasylvaApi);

document.addEventListener('DOMContentLoaded', () => {
  if (document.getElementById('help-wrapper')) {
    new Vue({
      render: (h) => h(Help),
    }).$mount('#help-wrapper');
  }
});
